import { motion, AnimatePresence } from "framer-motion";
import { Crosshair, Flame, X } from "lucide-react";
import { useSim } from "../lib/store";

// Compact "Active Epicenters" stack, top-left under the view toggle. Click a row to fly the
// globe camera to that pin; the X removes it. Desktop-only (mobile uses the ControlDeck menu).
export function EventManager() {
  const events = useSim((s) => s.events);
  const selectedId = useSim((s) => s.selectedId);
  const removeEvent = useSim((s) => s.removeEvent);
  const flyToEvent = useSim((s) => s.flyToEvent);

  return (
    <div className="hidden lg:block fixed top-32 left-4 z-[45] w-60">
      <AnimatePresence>
        {events.length > 0 && (
          <motion.div
            data-testid="active-epicenters-panel"
            initial={{ opacity: 0, x: -16 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -16 }}
            transition={{ duration: 0.3 }}
            className="flex flex-col gap-1.5"
          >
            <h3 className="text-[10px] font-mono-tele uppercase tracking-[0.22em] leading-loose text-[#c9a94a] px-1 pt-0.5">
              Active Epicenters
            </h3>
            {events.map((e, i) => (
              <div
                key={e.id}
                data-testid={`epi-row-${e.id}`}
                onClick={() => flyToEvent(e.id)}
                title="Fly to this epicenter"
                className={`group flex items-center gap-2 rounded-lg px-2.5 py-2 border cursor-pointer backdrop-blur-xl transition-all ${
                  selectedId === e.id
                    ? "bg-red-950/50 border-red-500/50"
                    : "bg-zinc-950/70 border-white/10 hover:border-[rgba(201,169,74,0.5)]"
                }`}
              >
                {e.type === "volcanic" ? <Flame className="h-3.5 w-3.5 text-orange-400 shrink-0" /> : <Crosshair className="h-3.5 w-3.5 text-red-400 shrink-0" />}
                <div className="flex-1 min-w-0">
                  <div className="font-mono-tele text-[11px] text-zinc-100 tabular-nums leading-tight">
                    {e.lat.toFixed(2)}°, {e.lon.toFixed(2)}°
                  </div>
                  <div className="font-mono-tele text-[9px] text-zinc-500 leading-tight">
                    {e.type === "volcanic" ? e.volcanoName : `Event ${i + 1}`} · Mw {e.magnitude.toFixed(1)} · {e.offshore ? "sea" : "land"}
                  </div>
                </div>
                <button
                  data-testid={`epi-remove-${e.id}`}
                  onClick={(ev) => { ev.stopPropagation(); removeEvent(e.id); }}
                  title="Remove epicenter"
                  className="shrink-0 h-7 w-7 flex items-center justify-center rounded-md bg-white/5 hover:bg-red-950/70 text-zinc-400 hover:text-red-300 transition-colors"
                >
                  <X className="h-3.5 w-3.5" />
                </button>
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
